import React from 'react';
import { upcomingEvents, getImageSrc } from "../api/FirebaseAPI";
import { FormatDate_ddd_MMM_d_yyyy } from "../lib/DateTimeFormatFunctions";
import { Grid, GridCell } from 'rmwc/Grid';
//import { history } from "react-router-dom";
import "./EventsPage.css";
import update from 'immutability-helper';

export default class EventsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      events:[],
    }
  }

  componentWillMount() {
    upcomingEvents(50)
    .then(result => {
        this.setState({events: result});
    })
    .then(() => {
      this.state.events.map((event) => {
        return getImageSrc(event.featureImageStorageName)
        .then((url) => {
          let i = this.state.events.indexOf(event);
          this.setState({events:update(this.state.events,
            {[i]:{"featureImageSrc":{$set:url}}}
          )});

          //this.setState({events:update(this.state.events, {i: {$set:event}})})
        })
        .catch((err) => {
          console.log(err);
        })
      });
    }
    );
  }


  render() {
    return (
      <div >
        <Grid className='events'>
          {this.state.events.map(event =>
              <EventsSummaryCell
                key={event.id}
                id={event.id}
                title={event.title}
                startDate={event.startDate}
                stopDate={event.stopDate}
                locality={event.locality}
                featureImageSrc={event.featureImageSrc}
              />
          )}
        </Grid>
      </div>
    );
  }
}

const EventDate = (props) => {
  return (
    <div className="events-date">{FormatDate_ddd_MMM_d_yyyy(props.startDate)}</div>
  );
}
const EventsSummaryCell = (props) => {
  return (
    <GridCell className="events-summary" key={props.id} span="4" desktop="4" >
      <a href={"./events/" + props.id} style={{textDecoration: "none"}}>
        <Image {...props} />
        <div style={{paddingLeft:"5px", paddingRight:"5px", paddingTop:"2px", paddingBottom:"3px"}}>
          <div className="events-title">{props.title}</div>
          <EventDate {...props} />
          <div className="events-locality">{props.locality}</div>
        </div>
        <div>
        </div>
      </a>
    </GridCell>
  )
}

const Image = (props) => {
  return (
    <img
      className="events-image"
      src={props.featureImageSrc}
      alt={props.featureImageStorageName}
    />
  );
}




/*
?search=%22A%22&page=1
var searchParams = new URLSearchParams(this.props.location.search);

*/



// WEBPACK FOOTER //
// ./src/containers/EventsPage.js